const state = {
    substudy: {},
    editInfoFormOpen: false,
    eligibilityStatusOptions: [],
    enrollmentStatusOptions: [],
    filter: null,
    saving: false,
    participants: [],
    selectedParticipants: [],
    sortDirection: 'asc',
    sortField: 'star_id'
}

const getters = {
    //
}

const mutations = {
    setEditInfoFormOpen(state, data) {
        return state.editInfoFormOpen = data
    },
    setEligibilityStatusOptions(state, data) {
        return state.eligibilityStatusOptions = data
    },
    setEnrollmentStatusOptions(state, data) {
        return state.enrollmentStatusOptions = data
    },
    setErrors (state, data) {
        return state.errors = data
    },
    setFilter(state, data) {
        return state.filter = data
    },
    setParticipants (state, data) {
        return state.participants = data
    },
    setSaving(state, data) {
        return state.saving = data
    },
    setSortDirection (state, data) {
        return state.sortDirection = data
    },
    setSortField (state, data) {
        return state.sortField = data
    },
    setSubstudy (state, data) {
        return state.substudy = data
    },
    updateSelectedParticipants (state, data) {
        return state.selectedParticipants = data
    },
}

const actions = {
    assignTask (context, data) {
        context.commit("setSaving", true)
        let url = '/api/substudies/'+state.substudy.id+'/assignTask'

        axios.post(url, {'participant_ids': state.selectedParticipants})
            .then((response) => {
                context.dispatch('fetchParticipants')
                context.commit("setSaving", false)
            }).catch((e) => {
                context.commit("setSaving", false)
                context.commit("setErrors", e.response.data.errors)
            })
    },
    fetchParticipants (context, data) {
        axios.get('/api/substudies/'+state.substudy.id+'/participants', {
            params: {
                sortField: state.sortField,
                sortDirection: state.sortDirection,
                filter: state.filter
            }
        })
        .then( (response) => {
            context.commit("setParticipants", response.data.data)
            context.commit("updateSelectedParticipants", [])
        })
        .catch( (e) => {
            console.log("Error: substudies.js, fetchParticipants(), "+ e.message)          
        })
    },
    setEligibilityStatusOptions (context, data) {
        context.commit("setEligibilityStatusOptions", data)
    },
    setEnrollmentStatusOptions (context, data) {
        context.commit("setEnrollmentStatusOptions", data)
    },
    setFilter (context, data) {
        context.commit("setFilter", data)
    },
    setSortDirection (context, data) {
        context.commit("setSortDirection", data)
    },
    setSortField (context, data) {
        context.commit("setSortField", data)
    },
    setSubstudy (context, data) {
        context.commit("setSubstudy", data)
    },
    toggleAllSelectedParticipants(context, allChecked) {
        if (allChecked) {
            context.commit("updateSelectedParticipants", [])
        } else {
            let partIds = []
            state.participants.forEach(function (participant) {
                partIds.push(participant.id)
            })
            context.commit("updateSelectedParticipants", partIds)
        }
    },
    updateSubstudyParticipant(context, data) {
        let url = '/api/substudies/'+state.substudy.id+'/updateSubstudyParticipant'
        let formData = {
            'participant_ids': state.selectedParticipants,
            'substudy_eligibility_id': data.eligibilityStatusId,
            'substudy_status_id': data.enrollmentStatusId
        }

        axios.post(url, formData)
            .then((response) => {
                context.dispatch('fetchParticipants')
                context.commit("setEditInfoFormOpen", false)
            }).catch((e) => {
                context.commit("setErrors", e.response.data.errors)
            })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}